import React from 'react';
import { useNavigate } from 'react-router-dom';

function CallToAction() {
  const navigate = useNavigate();
  return (
    <section className="w-full mt-16 max-md:mt-10">
      <div className="w-[90%] mx-auto relative min-h-[442px] max-md:min-h-[300px]">
        <img
          src="https://api.builder.io/api/v1/image/assets/2a838274f46548a0b8b8310254100157/26f2155bfcd927df8e5d16491ce4388bd885a232?placeholderIfAbsent=true"
          alt="Elegant jewelry background"
          className="object-cover w-full h-full min-h-[442px] max-md:min-h-[300px] object-center lg:object-right"
        />
        <div className="absolute inset-0 flex items-center justify-start lg:justify-start px-8 lg:px-20 max-md:px-4">
          <div className="text-white max-w-[671px] lg:mr-8">
            <h2 className="text-4xl lg:text-7xl underline max-md:text-3xl font-bold leading-tight">
              Elegance Redefined
            </h2>
            <p className="mt-8 text-xl lg:text-2xl font-light max-md:text-lg max-md:mt-4">
              Discover the timeless beauty of handcrafted jewellery
            </p>
            <button className="inline-block px-6 py-4 mt-8 text-xl lg:text-2xl font-bold text-center border-2 border-solid bg-transparent border-zinc-300 shadow-[0px_4px_4px_rgba(0,0,0,0.25)] hover:bg-white hover:text-black transition-colors max-md:px-4 max-md:py-3 max-md:text-lg max-md:mt-4 whitespace-nowrap"
            onClick={()=>navigate('/products')}>
              Shop Now
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CallToAction;
